<template>
  <div class="relative w-max">
    <BaseText type="body" size="sm" class="text-text-muted py-3 px-3">
      {{ formattedDateRange }}
    </BaseText>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CreationDateRangeCell',
  props: {
    dateRange: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedDateRange() {
      const { start, end } = this.dateRange
      if (!start || !end) return '-'
      const formattedStart = moment(start).format('YYYY/MM/DD')
      const formattedEnd = moment(end).format('YYYY/MM/DD')
      if (formattedStart === formattedEnd) return formattedStart
      return `${formattedStart} - ${formattedEnd}`
    }
  }
}
</script>